import styled from "styled-components";
import UserProfile from "./UserProfile";
import TeamProfile from "./TeamProfile";
import { useSelector } from "react-redux";
import ApiInterface from "utils/ApiInterface";
import React, { useState, useEffect } from "react";

const Wrapper = styled.div`
  margin-top: 18px;
  padding: 1rem;
  font-size: 14px;
  line-height: 19px;
  color: #ffffff;

  label {
    font-size: 10px;
    background-color: #353535 !important;
  }

  input {
    font-size: 14px !important;
  }
`;

const Tabs = styled.div`
  margin-bottom: 30px;

  button {
    padding-bottom: 5px;
    font-weight: 700;
    font-size: 15px;
    line-height: 19px;
    font-family: Roboto;
    color: #a0a0a0;
    outline: none;

    &:not(:first-child) {
      margin-left: 22px;
    }

    &.active {
      color: #e5e5e5;
      border-bottom: solid 2px #487bf2;
    }
  }
`;

const Profile = () => {
  const [tab, setTab] = useState("user");
  const [teams, setTeams] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const profile = useSelector(state => state.profile.profile);

  const setActiveTab = (tab) => () => {
    setTab(tab);
  };

  const getTeamMembers = async () => {
    let response = await ApiInterface.instance.getUserTeamMembers();
    setTeamMembers(response.data);
  }

  useEffect(() => {
    if (profile) {
      setTeams([profile.team]);
      getTeamMembers();
    }
  }, [profile]);

  return (
    <Wrapper>
      <Tabs>
        <button className={tab === "user" ? "active" : null} onClick={setActiveTab("user")}>
          User
        </button>
        <button className={tab === "team" ? "active" : null} onClick={setActiveTab("team")}>
          Team Members
        </button>
      </Tabs>
      {tab === "user" && <UserProfile />}
      {tab === "team" && <TeamProfile teams={teams} members={teamMembers} />}
    </Wrapper>
  );
};

export default Profile;